import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jnlis645GoodResponse: {
		id: 'atlassian-intelligence.prompt-response.feedback.jnlis645-good-response',
		defaultMessage: 'Good response',
		description: 'Updated tooltip for a like (thumbs up) button',
	},
	jnlis645BadResponse: {
		id: 'atlassian-intelligence.prompt-response.feedback.jnlis645-bad-response',
		defaultMessage: 'Bad response',
		description: 'Updated tooltip for a dislike (thumbs down) button',
	},
});
